
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { SystemQuery } from 'enums/SystemQuery';
import { PoolModel } from './Entities.GormCrm.Pool';
import { Model, ModelProperty } from 'models/Model';


export class QueryModel extends Model<QueryModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'system', type: 'SystemQuery', languageString: 'query.property.system' },
		{ name: 'id', type: 'guid', languageString: 'query.property.id', isHidden: true },
		{ name: 'name', type: 'string', languageString: 'query.property.name' },
		{ name: 'created', type: 'Date', languageString: 'query.property.created', isHidden: true },
		{ name: 'deleted', type: 'Date', languageString: 'query.property.deleted', isHidden: true },
		{ name: 'data', type: 'string', languageString: 'query.property.data' },
		{ name: 'description', type: 'string', languageString: 'query.property.description' },
		{ name: 'pools', type: 'PoolModel[]', languageString: 'query.property.pools', isHidden: true, isArray: true, isObject: true, new: () => { return new PoolModel }, properties: () => { return PoolModel.classProperties } }
	];
	[key: string]: any;
	
	public system?: SystemQuery;
	public id?: string;
	public name: string;
	public created?: Date;
	public deleted?: Date;
	public data: string;
	public description: string;
	public pools: PoolModel[];
    
	constructor(){
		super();
		this.system = undefined;
		this.id = undefined;
		this.name = '';
		this.created = undefined;
		this.deleted = undefined;
		this.data = '';
		this.description = '';
		this.pools = [];
		
	}
	getProperties(){
		return QueryModel.classProperties;
	}
}

